// Comprime una imagen en el navegador ANTES de subirla (ver Obtenerlinkimagen
// en utils/Querypanel.js). Se usa solo para imagenes que se muestran en la
// pagina publica (portadas, mapas, banners de publicidad): se subian tal cual
// y habia PNG de 3-10 MB (ej. banners 2812x682) que hacian lenta la carga.
//
// - Redimensiona a `maxAncho` (sin agrandar nunca).
// - Sin transparencia -> JPEG (mucho mas liviano que PNG para fotos/artes).
// - Con transparencia -> PNG redimensionado (no se pierde el fondo).
// - Si algo falla, o el resultado no es mas chico, devuelve el archivo
//   original: nunca bloquea la subida.
// - GIF / SVG / PDF / otros no se tocan.

const TIPOS_COMPRIMIBLES = ["image/jpeg", "image/png", "image/webp"];

function cargarImagen(file) {
    return new Promise((resolve, reject) => {
        const url = URL.createObjectURL(file);
        const img = new Image();
        img.onload = () => {
            URL.revokeObjectURL(url);
            resolve(img);
        };
        img.onerror = (e) => {
            URL.revokeObjectURL(url);
            reject(e);
        };
        img.src = url;
    });
}

function tieneTransparencia(ctx, ancho, alto) {
    const { data } = ctx.getImageData(0, 0, ancho, alto);
    for (let i = 3; i < data.length; i += 4) {
        if (data[i] < 255) return true;
    }
    return false;
}

function canvasABlob(canvas, tipo, calidad) {
    return new Promise((resolve) => canvas.toBlob(resolve, tipo, calidad));
}

/**
 * @param {File} file
 * @param {{ maxAncho?: number, calidad?: number }} [opciones]
 * @returns {Promise<File>} archivo comprimido, o el original si no conviene
 */
export async function comprimirImagen(file, { maxAncho = 1920, calidad = 0.82 } = {}) {
    try {
        if (!(file instanceof Blob) || !TIPOS_COMPRIMIBLES.includes(file.type)) return file;

        const img = await cargarImagen(file);
        const escala = Math.min(1, maxAncho / img.naturalWidth);
        const ancho = Math.max(1, Math.round(img.naturalWidth * escala));
        const alto = Math.max(1, Math.round(img.naturalHeight * escala));

        const canvas = document.createElement("canvas");
        canvas.width = ancho;
        canvas.height = alto;
        const ctx = canvas.getContext("2d");
        ctx.drawImage(img, 0, 0, ancho, alto);

        const conAlfa = file.type !== "image/jpeg" && tieneTransparencia(ctx, ancho, alto);
        const tipo = conAlfa ? "image/png" : "image/jpeg";
        const blob = await canvasABlob(canvas, tipo, calidad);
        if (!blob || blob.size >= file.size) return file;

        const base = (file.name || "imagen").replace(/\.[^.]+$/, "");
        const extension = tipo === "image/png" ? ".png" : ".jpg";
        return new File([blob], base + extension, { type: tipo, lastModified: Date.now() });
    } catch (error) {
        return file;
    }
}
